module.exports = __webpack_public_path__ + "static/img/hall05.d97c757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/hall05.jpg
// module id = eWvt
// module chunks = 1